import moment from "moment";

// Le statistiche distinguono sempre presenza sconosciuta e misurazione mancante.
export function summarizeTrainings(records) {
	const present = records.filter((r) => r.presenceStatus === "Presente");
	const knownMinutes = present.filter((r) => r.presenceDuration != null);
	const withRpe = present.filter((r) => r.playerRpe != null);
	const withLoad = present.filter((r) => r.trainingLoad != null);
	return {
		total: records.length,
		attendances: present.length,
		absences: records.filter((r) => r.presenceStatus === "Assente").length,
		injuries: records.filter((r) => r.presenceStatus === "Infortunato").length,
		unknown: records.filter(
			(r) => !["Presente", "Assente", "Infortunato"].includes(r.presenceStatus),
		).length,
		minutes: knownMinutes.length
			? knownMinutes.reduce((sum, r) => sum + r.presenceDuration, 0)
			: present.length ||
				  records.some(
						(r) => !["Assente", "Infortunato"].includes(r.presenceStatus),
				  )
				? null
				: 0,
		minutesCount: knownMinutes.length,
		otherRosters: present.filter(
			(r) => r.rosterId && r.otherConvocations === true,
		).length,
		withoutRoster: present.filter((r) => !r.rosterId).length,
		rpe: withRpe.length
			? withRpe.reduce((sum, r) => sum + r.playerRpe, 0) / withRpe.length
			: null,
		rpeCount: withRpe.length,
		minRpe: withRpe.length
			? Math.min(...withRpe.map((r) => r.playerRpe))
			: null,
		maxRpe: withRpe.length
			? Math.max(...withRpe.map((r) => r.playerRpe))
			: null,
		load: withLoad.length
			? withLoad.reduce((sum, r) => sum + r.trainingLoad, 0)
			: present.length ||
				  records.some(
						(r) => !["Assente", "Infortunato"].includes(r.presenceStatus),
				  )
				? null
				: 0,
		loadCount: withLoad.length,
	};
}

export function trainingWeeks(records) {
	const groups = new Map();
	records.forEach((record) => {
		const key = moment(record.startDate)
			.startOf("isoWeek")
			.format("YYYY-MM-DD");
		if (!groups.has(key)) groups.set(key, []);
		groups.get(key).push(record);
	});
	return [...groups.entries()]
		.sort(([a], [b]) => b.localeCompare(a))
		.map(([date, rows]) => ({date, ...summarizeTrainings(rows)}));
}
